/* esm.sh - micromark-util-normalize-identifier@2.0.1 */
function r(e){return e.replace(/[\t\n\r ]+/g," ").replace(/^ | $/g,"").toLowerCase().toUpperCase()}export{r as normalizeIdentifier};
//# sourceMappingURL=micromark-util-normalize-identifier.mjs.map